module.exports = __webpack_public_path__ + "img/home1.168183ac.png";